import styled from "@emotion/styled";
import { PlayArrow } from "@mui/icons-material";
import { Box, ListItemAvatar, Avatar as MuiAvatar } from "@mui/material";
import CircularProgressWithLabel from "components/CircularProgressWithLabel";
import { FilePreviewIcon } from "components/icons";
import { useLazyEffect } from "hooks";
import { useState } from "react";
import { getThumbnailUrlCache } from "services/attachment.service";
import { FileUtil, isAudio, isImage, isVideo } from "utils";

// file = { attachmentId, aesKeyInfo, metaData }
// url: local path
const FileAvatar = ({ url, file, progress = 0, loading = false }) => {
  const fileName = file.metaData?.fileName || "";
  const mimeType = file.metaData?.mimeType || "";
  const filePreviewIconColor = fileName ? FileUtil.getFileColor(fileName) : "";

  const [fileUrl, setFileUrl] = useState();

  useLazyEffect(() => {
    let isMounted = true;
    if ((isImage(mimeType) || isVideo(mimeType)) && url) {
      getThumbnailUrlCache(file, url).then(thumbnail => {
        if (isMounted) setFileUrl(thumbnail.mediaPath);
      });
    }

    return () => {
      isMounted = false;
    };
  }, [file, url]);

  return (
    <ListItemAvatar>
      <AvatarWrapper>
        <Avatar alt={`Avatar - ${fileName}`}>
          {(isImage(mimeType) || isVideo(mimeType)) && fileUrl ? (
            <img src={fileUrl} alt={fileName} />
          ) : isAudio(mimeType) ? (
            <Box className="flex-center">
              <PlayArrow fontSize="large" />
            </Box>
          ) : (
            <FilePreviewIcon color={filePreviewIconColor} />
          )}
        </Avatar>
        {loading && <CircularProgressWithLabel value={progress} size={48} />}
      </AvatarWrapper>
    </ListItemAvatar>
  );
};

export default FileAvatar;

const AvatarWrapper = styled(Box)({
  position: "relative", // Đặt vị trí tương đối để làm gốc cho các phần tử con
  width: 48,
  height: 48,
});

const Avatar = styled(MuiAvatar)(props => ({
  width: "100%",
  height: "100%",
  backgroundColor: props.theme.palette.white,
  color: props.theme.palette.grey[400],

  "& img, & video": {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },

  "& .flex-center": {
    width: "100%",
    height: "100%",
    backgroundColor: props.theme.palette.grey[400],
    color: props.theme.palette.white,
  },
}));
